module.exports = __webpack_public_path__ + "img/logo_cmyk.45ab0281.png";